import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

// A conversa de origem do pedido: gravada pelo banco quando o pedido nasce
// (pedido_conversa). O botão Conversa só abre, não procura.
export async function buscarConversaDoPedido(pedidoId: string): Promise<string | null> {
  const { data, error } = await supabase
    .from("pedido_conversa")
    .select("conversa_id")
    .eq("pedido_id", pedidoId)
    .maybeSingle();
  if (error) throw error;
  return data?.conversa_id ?? null;
}

export function usePedidoConversa(pedidoId: string | null | undefined, enabled = true) {
  return useQuery({
    queryKey: ["pedido-conversa", pedidoId],
    enabled: !!pedidoId && enabled,
    staleTime: 5 * 60_000,
    queryFn: () => buscarConversaDoPedido(pedidoId as string),
  });
}
